<template>
  <div>
    <v-app-bar flat color="transparent">
      <v-toolbar-title>
        <router-link class="text-decoration--none" :to="{name: 'users'}">Users</router-link>
        <v-icon> {{ icons.arrow }} </v-icon>
        <span v-if="form" class="text-capitalize">{{ form.full_name }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-light mb-10 text-capitalize">
        {{ form.full_name }}
      </div>

      <avatar-form :user="user" @change="avatarChange" @avatarRemove="userAvatarRemoved"/>

      <v-form ref="form" v-if="form" style="max-width: 400px">
        <label class="text-field-label pl-4"> Full name </label>
        <v-text-field
          flat solo rounded
          required
          background-color="grey lighten-3"
          class="mt-2"
          v-model="form.full_name"
          :error-messages="form.$getError('full_name')"
        ></v-text-field>

        <label class="text-field-label pl-4"> Email Address </label>
        <v-text-field
          flat solo rounded
          readonly
          required
          class="mt-2"
          background-color="grey lighten-3"
          v-model="form.email"
          :error-messages="form.$getError('email')"
        >
          <v-tooltip slot="append" top v-if="user.email">
            <template v-slot:activator="{ on }">
              <v-icon color="success" v-on="on" v-if="user.email_verified"> {{ icons.check }} </v-icon>
              <v-icon color="warning" v-on="on" v-else> {{ icons.alert }} </v-icon>
            </template>
            <span v-if="user.email_verified">Email Verified</span>
            <span v-else>Unverified email</span>
          </v-tooltip>
        </v-text-field>

        <label class="text-field-label pl-4"> Phone number </label>
        <v-text-field
          flat solo rounded
          required
          class="mt-2"
          background-color="grey lighten-3"
          v-model="form.phone_number"
          :error-messages="form.$getError('phone_number')"
        >
          <v-tooltip slot="append" top v-if="user.phone_number">
            <template v-slot:activator="{ on }">
              <v-icon color="success" v-on="on" v-if="user.phone_number_verified"> {{ icons.check }} </v-icon>
              <v-icon color="warning" v-on="on" v-else> {{ icons.alert }} </v-icon>
            </template>
            <span v-if="user.phone_verified">Phone Number Verified</span>
            <span v-else>Unverified Phone Number</span>
          </v-tooltip>
        </v-text-field>

        <label class="text-field-label pl-4"> Account Status </label>
        <v-select
          required
          class="mt-2"
          flat solo rounded
          :items="account_status"
          v-model="form.account_status"
          label="Select Account Status"
          background-color="grey lighten-3"
        ></v-select>

        <v-btn color="primary" depressed large class="mr-4" @click="updateUserDetails" :loading="form.$busy" rounded>
          Update
        </v-btn>
      </v-form>
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.show" right>
      {{ snackbar.message }}
      <v-btn color="pink" text @click="snackbar.show = false">
        Ok
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mdiChevronRight, mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import AvatarForm from './components/AvatarForm'

import Form from '@/utils/form'

export default {
  name: 'UserDetails',

  components: {
    AvatarForm
  },

  data () {
    return {
      icons: {
        arrow: mdiChevronRight,
        check: mdiCheck,
        alert: mdiAlertCircleOutline
      },
      account_status: [
        {
          text: 'Active',
          value: 'active'
        },
        {
          text: 'Blocked',
          value: 'blocked'
        }
      ],
      loading: false,
      avatarLoading: false,
      form: null,
      showCropperModal: false,
      avatarTimestamp: new Date().getTime(),
      snackbar: {
        show: false,
        message: null
      }
    }
  },

  computed: {
    ...mapState({
      user: state => state.user.userDetails,
      authUser: state => state.auth.user
    })
  },

  methods: {
    ...mapActions({
      getUserDetails: 'user/getUserDetails',
      changeAvatar: 'user/changeAvatar',
      updateUser: 'user/updateUser'
    }),

    ...mapMutations({
      clearUserDetails: 'user/clearUserDetails',
      setSelectedUserAvatar: 'user/setSelectedUserAvatar',
      userAvatarRemoved: 'user/userAvatarRemoved'
    }),

    async getUser () {
      this.loading = true
      await this.getUserDetails(this.$route.params.id)
      this.form = new Form(this.user)
      this.loading = false
    },

    async avatarChange (image) {
      this.avatarLoading = true
      let data = new FormData()
      data.append('user_id', this.user.id)
      data.append('avatar', image)
      await this.changeAvatar(data)
      this.avatarLoading = false
      this.showSnackbar('Avatar successfully updated!')
    },

    async updateUserDetails () {
      this.form.$busy = true
      this.form.$clearErrors()
      this.updateUser({
        id: this.user.id,
        full_name: this.form.full_name,
        email: this.form.email,
        phone_number: this.form.phone_number,
        account_status: this.form.account_status
      }).then(() => {
        this.form.$busy = false
        this.showSnackbar('User details successfully updated!')
      }).catch(err => {
        this.form.$busy = false
        if (err.response.status === 422) {
          this.form.$setErrors(err.response.data.errors)
        }
      })
    },

    showSnackbar (message) {
      this.snackbar.message = message
      this.snackbar.show = true
    }
  },

  created () {
    this.getUser()
  },

  destroyed () {
    this.clearUserDetails()
  },

  watch: {
    $route () {
      this.getUser()
    }
  }
}
</script>

<style>

</style>
